import { useContext, createContext } from 'react'

export const ContentFormContext = createContext(null)

export const useContentForm = () => {
  return useContext(ContentFormContext)
}
